import { ContainerGlogal } from "@Components/ContainerGlogal"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { Platform, StyleSheet, TouchableOpacity, View } from "react-native"
import { IconButton } from "react-native-paper"
import Constants from "expo-constants"
import { MaterialCommunityIcons } from "@expo/vector-icons"

export const GoalFinished = ({ navigation }) => {
    const goBackToFollowUp = () => {
        navigation.navigate("Main", { screen: "FollowUpStack", params: { screen: "Goals" } })
    }

    const goBack = () => {
        navigation.goBack()
    }

    return (
        <ContainerGlogal style={styles.container}>
            {/* <IconButton
                rippleColor={"rgba(0,0,0,0.05)"}
                onPress={() => goBack()}
                icon="close"
                color={"white"}
                size={35}
                style={{ alignSelf: "flex-end" }}
            /> */}

            <TouchableOpacity onPress={() => goBack()} style={{ alignSelf: "flex-end", padding: 20 }}>
                <MaterialCommunityIcons name={"close"} size={35} color={"white"} />
            </TouchableOpacity>

            <BreeSerifText fontSize={28} textAlign="center" color={"white"}>
                Félicitations
            </BreeSerifText>
            <Spacer height={20} />
            <OpenSansText fontSize={18} color={baseColors.white}>
                Vous avez validé votre objectif !
            </OpenSansText>
            <SvgMascotte style={{ marginVertical: 50 }} width={278} height={278} />
            <OpenSansText color={"white"} fontSize={16} textAlign="center">
                Continuez sur votre lancée et validez vos autres objectifs !
            </OpenSansText>
            <View style={{ height: 30 }}></View>

            <Button
                onPress={() => goBackToFollowUp()}
                text="Voir mes objectifs"
                width="70%"
                backgroundColor={"white"}
                labelColor={baseColors.green.dark}
            />
            <View style={{ height: 100 }}></View>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 20,
        justifyContent: "center",
        alignItems: "center",
        paddingTop: Platform.OS == "android" ? 80 : Constants.statusBarHeight,
        backgroundColor: baseColors.green.dark
    }
})
